"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _removeSpaces = require("../../utils/removeSpaces");
var _LunaLink = _interopRequireDefault(require("../LunaLink/LunaLink"));
var _Image = _interopRequireDefault(require("../Image/Image"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const GlobalFooter = _ref => {
  let {
    logo,
    globalFooterText,
    legalStuff
  } = _ref;
  const getCurrentYear = () => {
    return new Date().getFullYear();
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("section", {
    className: "ter-footer__section"
  }, logo && /*#__PURE__*/_react.default.createElement("figure", {
    role: "none",
    className: "ter-footer__logo-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
    href: "https://www.trimble.com/",
    target: "_blank",
    className: "ter-footer__logo",
    rel: "noopener noreferrer",
    ariaLabel: "Go to the homepage",
    tabIndex: "0"
  }, logo && /*#__PURE__*/_react.default.createElement(_Image.default, {
    image: logo?.image || null,
    src: (0, _removeSpaces.removeSpaces)(logo?.url || logo?.src),
    alt: logo?.altText || logo?.alt,
    GatsbyImage: logo?.GatsbyImage
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-footer__logo-date"
  }, "\xA9 ", getCurrentYear(), " Trimble Inc."))), /*#__PURE__*/_react.default.createElement("section", {
    className: "ter-footer__section ter-footer__section--text"
  }, globalFooterText && /*#__PURE__*/_react.default.createElement("p", {
    className: "ter-footer__text"
  }, globalFooterText)), legalStuff && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("section", {
    className: "ter-footer__section ter-footer__section--spacer"
  }), /*#__PURE__*/_react.default.createElement("section", {
    className: "ter-footer__section"
  }, /*#__PURE__*/_react.default.createElement("nav", {
    className: "ter-footer__legal-stuff"
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "ter-footer__legal-items"
  }, legalStuff.map((link, index) => {
    const iconImageOriginalHeight = link?.iconImage?.image?.height;
    const iconImageOriginalWidth = link?.iconImage?.image?.width;
    const iconImageAspectRatio = Number(parseFloat(iconImageOriginalWidth / iconImageOriginalHeight).toFixed(2));

    // default icon image height to 16px
    const iconImageHeight = 16;

    // preserve the default image dimension, but cap at 40px for icon image width
    const iconImageWidth = iconImageHeight * iconImageAspectRatio >= 40 ? 40 : iconImageHeight * iconImageAspectRatio;
    return /*#__PURE__*/_react.default.createElement("li", {
      key: `${link?.text}-${index}`,
      className: "ter-footer__legal-item"
    }, link?.url && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
      className: "ter-footer__legal-stuff-link",
      href: link?.url,
      rel: link.external === false ? "" : "noopener noreferrer",
      tabIndex: "0",
      target: typeof link?.external === "boolean" ? link?.external ? "_blank" : "_self" : null,
      ariaLabel: link?.external === true ? `Open ${link.text} in a new tab` : `Navigate to ${link.text}`
    }, link.text), link?.iconImage?.image && /*#__PURE__*/_react.default.createElement("img", {
      className: "ter-footer__legal-stuff-icon",
      src: link?.iconImage?.image?.file?.url,
      alt: link?.iconImage?.altText ? link?.iconImage?.altText : "icon",
      style: {
        height: `${iconImageHeight}px`,
        width: `${iconImageWidth}px`
      }
    })), !link.url && /*#__PURE__*/_react.default.createElement("p", {
      className: "ter-footer__legal-stuff-link"
    }, link?.text));
  }))))));
};
var _default = GlobalFooter;
exports.default = _default;